// extracted by mini-css-extract-plugin
export var phone = "_1t-0";
export var phoneDragging = "_1t-1";